import React from "react";
import { TimeValue } from "react-aria";
import { TimeFieldStateOptions } from "react-stately";
import { TimeField } from "./time-field";

interface TimePickerProps extends TimeFieldStateOptions<TimeValue> {
  className?: string;
}

const TimePicker = React.forwardRef<
  HTMLDivElement,
  Omit<TimePickerProps, "locale">
>((props) => {
  return <TimeField {...props} />;
});

TimePicker.displayName = "TimePicker";

export { TimePicker };
